import React, { Suspense, lazy, useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LoadingProvider } from './context/LoadingContext';
import Loading from './components/Loading';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import './index.css';

// Lazy load pages
const Home = lazy(() => import('./pages/Home'));
const Courses = lazy(() => import('./pages/Courses'));
const About = lazy(() => import('./pages/About'));
const ContactUs = lazy(() => import('./pages/ContactUs'));
const RegisterForm = lazy(() => import('./components/RegisterForm'));

function App() {
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    // Simulate initial app loading
    // const timer = setTimeout(() => {
      setInitialLoading(false);
    // }, 1500);

    
    // return () => clearTimeout(timer);
  }, []);

  if (initialLoading) {
    return <Loading message="Initializing Hegra Vision..." />;
  }

  return (
    <LoadingProvider>
      <Router>
        <div className="min-h-screen flex flex-col">
          <Navbar />
          
          <main className="flex-1">
            <Suspense fallback={<Loading message="Loading page..." />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/courses" element={<Courses />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<ContactUs />} />
                <Route path="/register" element={<RegisterForm />} />
              </Routes>
            </Suspense>
          </main>

          <Footer />
        </div>
      </Router>
    </LoadingProvider>
  );
}

export default App;